// src/theme.js
const theme = {
  colors: {
    // THESE VARY DEPENDING ON YOUR DESIGN
    primary: "#6633db",
    lightPrimary: "rgba(102, 51, 219, 0.5)",
    lighertPrimary: "rgba(102, 51, 219, 0.1)",
    // THESE ARE FIXED
    white: "#ffffff",
    transparentWhite: "rgba(255, 255, 255, 0.7)",
    offBlack: "#111111",
    black: "rgba(0, 0, 0, 0.5)",
    lightBlack: "rgba(0, 0, 0, 0.1)",
    red: "#ff5e4f",
    green: "#58E07E",
    grey: "#757575",
    darkGrey: "#666666",
    lightGrey: "#f5f5f5",
  },
  shadows: {
    // THESE VARY DEPENDING ON YOUR DESIGN
    regular: "0px 40px 80px rgba(0, 0, 0, 0.1)",
    chat: "0px 4px 10px rgba(72, 30, 201, 0.1)",
    email: "0px 6px 20px rgba(0, 0, 0, 0.07)",
  },
  breakpoints: {
    sm: "480px",
    md: "768px",
  },
};

export default theme;
